import React, { useState, useEffect } from 'react';
import { PenTool, FileText, CheckCircle, Maximize2 } from 'lucide-react';
import apiService from '../../services/apiService';

// ── ПАЛИТРА ЭКРАНА «СЕГОДНЯ» → §3.1 (Ф1, quick-260909-jl8) ─────────────────
// Откат в каждой строке — ПРЕЖНИЙ литерал ЭТОГО ЖЕ места. На fitenko токен
// объявлен (styles/fitenko-tokens.css, селектор html.fitenko) и берётся он;
// на MLG и ELN токена НЕТ — берётся откат, то есть РОВНО прежний цвет.
// 🔴 Значения отката менять нельзя: ими доказывается неизменность чужих арендаторов.
// 🔴 Голый var(--ink) запрещён: у MLG он разрешается в ПУСТОТУ (отсутствие цвета),
//    а не в другой цвет — объявление становится недействительным.
// Класс C (подложки чипов) — по решению владельца от 2026-09-09, вариант B:
// подложка выводится правилом color-mix(in srgb, АКЦЕНТ 14%, --surface); правило
// объявлено ОДИН раз в pages/Dashboard.css под селектором html.fitenko. Бирюза —
// вариант T1: своего тона в §3.1 нет, берётся --green-accent.
const P = {
    inkDeep:     'var(--ink, #0f172a)',  // класс A
    muted:       'var(--ink-muted, #64748b)',  // класс A
    surfaceSoft: 'var(--surface-soft, #f1f5f9)',  // класс A
    purple1:     'var(--purple-accent, #9333ea)',  // класс B
    chipPurple1: 'var(--chip-purple-bg, #f3e8ff)',  // класс C
};




const ContentFactoryWidget = ({ locationId = null, articlesCreated, snippetsFixed }) => {
    const [stats, setStats] = useState({
        created: 0,
        active: 0,
        fixed: 0
    });

    useEffect(() => {
        // [FIX] Use passed props if available (from Dashboard API)
        if (articlesCreated !== undefined || snippetsFixed !== undefined) {
            setStats(prev => ({
                ...prev,
                created: articlesCreated || 0,
                fixed: snippetsFixed || 0
            }));
            return;
        }

        const fetchStats = async () => {
            try {
                let endpoint = '/reputation/tasks/stats';
                if (locationId) {
                    endpoint += `?location_id=${locationId}`;
                }
                const data = await apiService.makeRequest(endpoint);
                setStats({
                    created: data.total_articles_created,
                    active: data.active_queue_size,
                    fixed: data.snippets_fixed
                });
            } catch (e) { console.error("Stats fetch error", e); }
        };
        fetchStats();
        const interval = setInterval(fetchStats, 30000);
        return () => clearInterval(interval);
    }, [locationId, articlesCreated, snippetsFixed]);

    return (
        <div className="hero-card-battle" style={{
            background: 'white', // [Enterprise] White
            cursor: 'default',
            minHeight: '220px',
            height: '100%',
            position: 'relative',
            overflow: 'hidden',
            borderRadius: '24px',
            border: `1px solid ${P.surfaceSoft}`,
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            padding: '24px'
        }}>
            {/* Header Area */}
            <div style={{ position: 'relative', zIndex: 2 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '20px' }}>
                    <div className="hero-icon-wrapper" style={{
                        width: '56px', height: '56px',
                        background: P.chipPurple1, // Purple-50
                        borderRadius: '16px',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        color: P.purple1, // Purple-600
                        flexShrink: 0
                    }}>
                        <PenTool size={28} fill="currentColor" />
                    </div>
                    <div>
                        <div style={{ fontSize: '0.85rem', fontWeight: '600', letterSpacing: '0.05em', textTransform: 'uppercase', color: P.muted }}>
                            Content Strategy
                        </div>
                        <div style={{ fontSize: '3rem', fontWeight: '800', lineHeight: 1, color: P.inkDeep, letterSpacing: '-0.02em', marginTop: '4px' }}>
                            {stats.active + stats.created}
                        </div>
                    </div>
                </div>
            </div>

            {/* Split Stats & CTA */}
            <div style={{ position: 'relative', zIndex: 2, marginTop: 'auto' }}>
                <div style={{ display: 'flex', gap: '32px', marginBottom: '20px' }}>
                    <div>
                        <div style={{ fontSize: '1.25rem', fontWeight: '700', color: P.inkDeep }}>{stats.created}</div>
                        <div style={{ fontSize: '0.75rem', color: P.muted, display: 'flex', alignItems: 'center', gap: '4px', fontWeight: '500' }}>
                            Articles
                        </div>
                    </div>
                    <div>
                        <div style={{ fontSize: '1.25rem', fontWeight: '700', color: P.inkDeep }}>{stats.fixed}</div>
                        <div style={{ fontSize: '0.75rem', color: P.muted, display: 'flex', alignItems: 'center', gap: '4px', fontWeight: '500' }}>
                            Fixed
                        </div>
                    </div>
                </div>

                <div style={{
                    borderTop: `1px solid ${P.surfaceSoft}`,
                    paddingTop: '16px',
                    display: 'flex', justifyContent: 'flex-start'
                }}>
                    <div className="hero-cta" style={{
                        fontSize: '0.9rem', color: P.purple1, // Purple-600
                        display: 'flex', alignItems: 'center', fontWeight: '600',
                        cursor: 'pointer', opacity: 1, transition: 'opacity 0.2s', gap: '6px'
                    }}>
                        Open Full Interface <Maximize2 size={16} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContentFactoryWidget;
